import { render } from "./Controller.vue?vue&type=template&id=047f1fe0&scoped=true"
import script from "./Controller.vue?vue&type=script&lang=js"
export * from "./Controller.vue?vue&type=script&lang=js"

import "./Controller.vue?vue&type=style&index=0&id=047f1fe0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047f1fe0"]])

export default __exports__